export default "__VITE_ASSET__Ci0woy0p__"